import Phaser from 'phaser';
import getConfig from '@config/baseConfig';
import sceneDefs from '@config/scenes';

/**
 * Initializes a Phaser game instance.
 * @returns {Phaser.Game} The initialized game instance
 */
export function initializeGame() {
  const config = getConfig();
  const game = new Phaser.Game(config);

  sceneDefs.forEach(({ key, scene, autoStart }) => {
    game.scene.add(key, scene, autoStart || false);
  });

  return game;
}
